const MISC_IMAGES_URL = 'https://tophamtechbeb.com/api/toptech/onboarding/v1/misc-images';
const API_KEY = 'treas-api-key-2025';

const parseResponse = async (response, fallbackMessage) => {
  let body = {};

  try {
    body = await response.json();
  } catch (error) {
    // Some upstream errors do not include a JSON response body.
  }

  if (!response.ok) {
    const requestError = new Error(body.error || body.detail || fallbackMessage);
    requestError.status = response.status;
    requestError.details = body;
    throw requestError;
  }

  return body;
};

export const getSiteModificationImages = async (siteId) => {
  const response = await fetch(`${MISC_IMAGES_URL}/${encodeURIComponent(siteId)}`, {
    headers: { 'X-API-Key': API_KEY }
  });

  const body = await parseResponse(response, 'Unable to load your images.');
  return Array.isArray(body.data) ? body.data : [];
};

export const uploadSiteModificationImages = async (siteId, files) => {
  const formData = new FormData();
  formData.append('site_id', siteId);
  files.forEach((file) => formData.append('images', file));

  const response = await fetch(MISC_IMAGES_URL, {
    method: 'POST',
    headers: { 'X-API-Key': API_KEY },
    body: formData
  });

  return parseResponse(response, 'Unable to upload your images.');
};

export const deleteSiteModificationImage = async (siteId, fileId) => {
  const response = await fetch(
    `${MISC_IMAGES_URL}/${encodeURIComponent(siteId)}/${encodeURIComponent(fileId)}`,
    {
      method: 'DELETE',
      headers: { 'X-API-Key': API_KEY }
    }
  );

  return parseResponse(response, 'Unable to delete this image.');
};
